/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import ManualAddressFields from '../../../Components/App/Address/ManualAddressFields';
import { useTailwindBrand } from '../../../Components/shared';
import { useAiciOnboardingContexte } from '../../../Contexts/AiciOnboardingContexte';
import StepShell from '../StepShell';
import ButtonField from 'src/Components/Ui/ButtonField';

const AddressStep = () => {
    const {
        address, addressErrors, setAddress, validateAddress, goToStep, saveAndGoTo, saving,
        birthBank,
    } = useAiciOnboardingContexte();
    const { classes } = useTailwindBrand();
    const [warning, setWarning] = useState(false);

    // Persiste l'adresse et passe à l'étape suivante (récapitulatif).
    const nextStep = () => {
        setWarning(false);
        saveAndGoTo(4);
    };

    const handleNext = () => {
        if (!validateAddress()) return;
        // Si la ville du domicile correspond à la ville de naissance, on demande confirmation.
        const sameCity =
            !!address.city &&
            !!birthBank.birthCity &&
            address.city.trim().toLowerCase() === birthBank.birthCity.trim().toLowerCase();
        console.log(sameCity)
        if (sameCity) {
            setWarning(true);
            return;
        }
        nextStep();
    };

    return (
        <>
        <StepShell
            title="Adresse de votre domicile"
            subtitle="Le ménage doit avoir lieu à votre domicile fiscal pour bénéficier du crédit d'impôt."
            onPrev={() => goToStep(2)}
            onNext={handleNext}
            nextLoading={saving}
            requiredLegend
        >
            <ManualAddressFields value={address} errors={addressErrors} onChange={setAddress} showLieuDit />
        </StepShell>

        <Dialog
            fullWidth
            open={warning}
            onClose={() => setWarning(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "08px",
                    position: "relative",
                    overflow: "visible",
                    boxShadow: "4px 10px 20px 0px rgba(0,0,0,0.25)"
                }
            }}
        >
            <div className="flex flex-col p-6 gap-y-4">
                <DialogTitle id="alert-dialog-title" className={`font-extrabold text-center uppercase ${classes.fontFamily}`}>
                    Vérification
                </DialogTitle>
                <DialogContent className="flex flex-col py-6 text-center gap-y-4">
                    <p className={`text-base font-semibold ${classes.text} ${classes.fontFamily}`}>
                        Vous êtes sur le point d'ajouter comme ville de naissance la même que celle où vous résidez actuellement.
                    </p>
                    <p className={`text-base font-semibold ${classes.text} ${classes.fontFamily}`}>
                        Voulez-vous continuer ?
                    </p>
                </DialogContent>
                <DialogActions className="justify-around gap-4">
                    {/* <BrandButton variant='outline' onClick={() => setWarning(false)} children="Non" />
                        <BrandButton onClick={nextStep} children="Oui" /> */}
                        <ButtonField label='Non' onClick={() => setWarning(false)} variant='outlined' />
                        <ButtonField label='Oui' onClick={nextStep} variant='contained' />
                </DialogActions>
            </div>
        </Dialog>
        </>
    );
};

export default AddressStep;
